import React, { FC } from 'react'

interface LineWithCircleProps {
    color: string
}

const LineWithCircle: FC<LineWithCircleProps> = ({ color }) => {
    return (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="auto" height="11" viewBox="0 0 343 11" fill="none">
                <rect y="5" width="160" height="1" fill={color} />
                <rect x="183" y="5" width="160" height="1" fill={color} />
                <circle cx="171.5" cy="5.5" r="5" stroke={color} />
            </svg>
        </div>
    )
}

export default LineWithCircle
